module.exports = __webpack_public_path__ + "static/media/ITA.ad162ba0.jpg";